import axios from 'axios'
import { TEST_URl } from '@/utils/constants.js'

const defaultBaseUrl = `${process.env.VUE_APP_BASE_URL}`
const testUrl = localStorage.getItem(TEST_URl)
const baseUrl = testUrl || defaultBaseUrl

export async function getDashboardReportService (status) {
  const statusParam = status ? `?status=${status}` : ''
  const res = await axios.get(`${baseUrl}/report/dashboard${statusParam}`)
  return res
}

export async function getCurrencyUpdateService (payload) {
  const res = await axios.get(
    `${baseUrl}/utils/currency-updates?from=${payload.fromCurrency}&to=${payload.toCurrency}&page=${payload.page}&size=${payload.size}&sort_by=created_at&sort_direction_desc=true`
  )
  return res
}

export async function getYieldService (payload) {
  const res = await axios.get(
    `${baseUrl}/yields?from=${payload.from}&to=${payload.to}`
  )
  return res
}
